export default {
  data () {
    return {
      routesName: [
        /login/,
        /registration/
      ]
    }
  },
  methods: {
    redirectAccess (redirect) {
      return Boolean(this.routesName.some(item => item.test(redirect)))
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/AccessMixin/AccessMixin.js